var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        display: "flex",
        "justify-content": "center",
        "align-items": "center"
      }
    },
    [
      _vm.bizType == "dingding"
        ? _c(
            "div",
            {
              staticClass: "dingding-icon",
              class: _vm.auditType ? "checked" : "",
              attrs: { title: "钉钉审批" },
              on: {
                click: function($event) {
                  _vm.changeChnl(true)
                }
              }
            },
            [
              _c("i", {
                staticClass: "icon iconfont icon-dingding",
                staticStyle: { "font-size": "46px" }
              })
            ]
          )
        : _c(
            "div",
            {
              staticClass: "dingding-icon",
              class: _vm.auditType ? "checked" : "",
              attrs: { title: "飞书审批" },
              on: {
                click: function($event) {
                  _vm.changeChnl(true)
                }
              }
            },
            [
              _c("i", {
                staticClass: "icon iconfont icon-feishu",
                staticStyle: { "font-size": "46px" }
              })
            ]
          ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "swb-logo-icon",
          class: !_vm.auditType ? "checked" : "",
          attrs: { title: "商维宝审批" },
          on: {
            click: function($event) {
              _vm.changeChnl(false)
            }
          }
        },
        [
          _c("img", {
            directives: [
              {
                name: "resc-url",
                rawName: "v-resc-url",
                value: "/app/image/logo/swb-white.png",
                expression: "'/app/image/logo/swb-white.png'"
              }
            ]
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48cd93f0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48cd93f0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/oaAudit/AuditType.vue
// module id = 2552
// module chunks = 0